import React from 'react';
import { compose, is } from 'ramda';
import styleFile from './PayPalContainer.js';
import { connect } from 'react-redux';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { List, Map } from 'immutable';
import { Button, Image } from '@synergycms_core/components/generic/';
import { withForm } from '@synergycms_core/components/generic/Form';
import { PCI_URL } from '../../../config/constants';

let setPayPalOrderId = false;

const PayPalContainer = class PayPalContainer extends React.Component {
  static displayName = 'PayPalContainer';

  /** @type {HTMLElement|null} */
  payPalScriptTag = null;
  /** @type {string} */
  payPalContainerID = 'PayPalContainer';
  /** @type {string|null} */
  orderID = null;
  /** @type {boolean} */
  buttonRendered = false;

  constructor(props) {
    super(props);
    const { payPalEnabled, payPalClientID, hotelCurrencyCode, langCode } = this.props.config;

    if (payPalEnabled) {
      new Promise((resolve, reject) => {
        this.payPalScriptTag = this.addPayPalScriptTag(payPalClientID, hotelCurrencyCode, langCode);

        const onErrorFunc = () => {
          setTimeout(() => {
            this.payPalScriptTag = this.addPayPalScriptTag(payPalClientID, hotelCurrencyCode, langCode);
            this.payPalScriptTag.onerror = onErrorFunc;
            this.payPalScriptTag.onload = onLoadFunc;
          }, 1000);
        };

        const onLoadFunc = () => {
          resolve('ok');
        };

        this.payPalScriptTag.onerror = onErrorFunc;
        this.payPalScriptTag.onload = onLoadFunc;
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { payFormSelected } = this.props.config;
    if (payFormSelected !== 'paypal') {
      this.buttonRendered = false;
    }
  }

  createOrder = (data, actions) => {
    const { PayPal } = this.props.config;
    // alert('Transaction completed by ' + details.payer.name.given_name);
    // Call your server to save the transactionget ele
    return PayPal.createTransaction().then((data) => {
      if (data.result !== undefined && data.result.id !== undefined && data.result.status === 'CREATED') {
        setPayPalOrderId(data.result.id);
        this.orderID = data.result.id;
        return data.result.id; // Use the same key name for order ID on the client and server
      }
    });
  };

  onApprove = (data) => {
    const { onGlobalSubmit, PayPal, manageLoading } = this.props.config;
    manageLoading(true);
    return PayPal.captureTransaction(this.orderID)
      .then((res) => {
        if (res.result !== undefined && res.result.id !== undefined && res.result.status === 'COMPLETED') {
          onGlobalSubmit();
          return res.result.id; // Use the same key name for order ID on the client and server
        } else {
          manageLoading(false);
        }
      });
  };

  loadButton = () => {
    const onLoadFunc = () => {
      setTimeout(() => {
        const container = document.getElementById(this.payPalContainerID);
        if (container && window.paypal !== undefined && !this.buttonRendered) {
          container.innerHTML = '';
          window.paypal.Buttons({
            createOrder: this.createOrder,
            onApprove: this.onApprove
          }).render('#' + this.payPalContainerID).then(() => {
            this.buttonRendered = true;
            window.dispatchEvent(new MessageEvent('message',
              {
                data: 'paypal_button_loaded:true',
                origin: PCI_URL,
              }));
          });
        } else {
          onLoadFunc();
        }
      }, 200);
    };
    onLoadFunc();
  };

  /**
   *
   * @param payPalClientID
   * @param hotelCurrencyCode
   * @param langCode
   * @returns {HTMLScriptElement}
   */
  addPayPalScriptTag = (payPalClientID, hotelCurrencyCode, langCode) => {
    const scriptPayPal = document.createElement('script');
    let locale;
    switch (langCode.toLowerCase()) {
      case 'es':
      case 'ca':
      case 'gl':
        locale = 'es_ES';
        break;
      case 'fr':
        locale = 'fr_FR';
        break;
      case 'it':
        locale = 'it_IT';
        break;
      case 'de':
        locale = 'de_DE';
        break;
      case 'pt':
        locale = 'pt_PT';
        break;
      case 'ru':
        locale = 'ru_RU';
        break;
      case 'nl':
        locale = 'nl_NL';
        break;
      case 'tr':
        locale = 'tr_TR';
        break;
      case 'zi':
        locale = 'zh_CN';
        break;
      case 'ar':
        locale = 'ar_AE';
        break;
      case 'hu':
        locale = 'hu_HU';
        break;
      case 'cs':
        locale = 'cs_CZ';
        break;
      case 'vi':
        locale = 'en_VN';
        break;
      case 'sk':
        locale = 'sk_SK';
        break;
      case 'ro':
        locale = 'en_RO';
        break;
      case 'pl':
        locale = 'pl_PL';
        break;
      case 'ja':
        locale = 'ja_JP';
        break;
      default:
        locale = 'en_US';
        break;
    }

    scriptPayPal.setAttribute(
      'src',
      'https://www.paypal.com/sdk/js?client-id=' + payPalClientID + '&disable-funding=sofort,credit,card&locale=' + locale + '&currency=' + hotelCurrencyCode
    );
    document.head.appendChild(scriptPayPal);
    return scriptPayPal;
  };

  render() {
    const { payPalEnabled, payFormSelected, validForm, onGlobalSubmit, reservationPaid } = this.props.config;
    const { deviceType } = this.props.theme;
    const { classes } = this.props.theme.styles;
    const sizeImage = deviceType === 'DESK' ? '' : '_large';

    if (payPalEnabled && payFormSelected === 'paypal' && !reservationPaid) {
      return (
        <div>
          <div
            id={this.payPalContainerID}
            onLoad={this.loadButton()}
            className={validForm ? '' : classes.hide}
          />
          <Button onClick={onGlobalSubmit} innerStyle={[!validForm ? '' : 'hide']} ariaLabel={'paypal'}>
            <Image src={'/assets/images/paypal_disabled' + sizeImage + '.png'}/>
          </Button>
        </div>
      );
    } else {
      return false;
    }
  }
};

const mapDispatchToProps = dispatch => {
  return {
    /*
    onNextClick: () => e => {
      e.preventDefault();
      dispatch(actions.events.trigger('next_step_2'));
      dispatch(actions.customer.step.next());
      dispatch(actions.customer.reservation.postAsync()).then(() => {
        dispatch(actions.router.update());
      });
    }
    */
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;
  const payPalEnabled = hotel.getIn(['paypal', 'name'], false);
  const payPalParams = hotel && hotel.getIn(['paypal', 'tpv_params'], List());
  const payPalClientID = payPalParams.find(p => p.get('code') === 'client_id', Map()).get('value', '');

  setPayPalOrderId = ownProps.setPayPalOrderId(ownProps.form.validForm, ownProps.form.inputList);

  return {
    payPalEnabled: payPalEnabled,
    payPalClientID: payPalClientID,
    hotelCurrencyCode: hotel.getIn(['currency', 'code']),
    validForm: ownProps.form.validForm,
    onGlobalSubmit: ownProps.form.onGlobalSubmit,
    manageLoading: ownProps.form.manageLoading
  };
};

export default compose(
  withForm(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'payPalEnabled',
    'payPalClientID',
    'payFormSelected',
    'hotelCurrencyCode',
    'PayPal',
    'validForm',
    'onGlobalSubmit',
    'manageLoading',
    'langCode',
    'reservationPaid'
  ]),
  withThemeJSS({ styleFile })
)(PayPalContainer);
